import React from 'react';
import './tooltip.style.css';

const Tooltip = (props) => {
    if (props.content) {
        return (
            <div className='tooltip'>
                {props.children}
                <span className='tooltiptext'>
					{props.content}{' '}
                    {props.linkUrl && props.linkLabel ? (
                        <a target='_blank' rel='noreferrer' href={props.linkUrl}>
                            [{props.linkLabel}]
                        </a>
                    ) : null}
				</span>
            </div>
        );
    } else {
        return props.children;
    }
};
export default Tooltip;
